import {
  VALID,
  isBlank,
  hcpcsOrUnitOfMeasureCrossFieldErrors,
  isValidNonFutureDate,
  isValidQuantity,
  isQuestionableQuantity,
  isValidNPI,
  isValidNCPDP,
  isValidDEA,
  isValidIdentifier,
  isValidId340b,
  isValidHealthPlanId,
  isValidHealthPlanName,
  isValidClaimNumber,
  isValidClaimLineNumber,
  isValidHCPCS,
  isValidHCPCSMod,
  isValidUnitOfMeasure,
  isValidWholesalerInvoiceNumber,
} from "./DataValidations";
import { isRequiredField } from "../Schemas/MedicalClaim";
import SubmissionTranslator from "../../../utils/SubmissionTranslator";

const translator = new SubmissionTranslator("medical");

const isValidMedicalClaimField = (value, column, row, mapping) => {
  if (["formatted_claim_number"].includes(column)) {
    return VALID;
  }

  const requiredResult = checkRequired(column, value);
  if (!requiredResult.isValid) {
    return requiredResult;
  }

  switch (column) {
    case "date_of_service":
      if (!isValidNonFutureDate(value)) {
        return { isValid: false, message: translator.getError("invalid_date") };
      }
      return VALID;

    case "ndc_11":
      return VALID;

    case "quantity":
      if (!isValidQuantity(value)) {
        return { isValid: false, message: translator.getError("invalid_quantity") };
      }
      if (isQuestionableQuantity(value)) {
        return { isValid: false, message: translator.getError("quantity_over_max") };
      }
      return VALID;

    case "rendering_physician_id":
      if (!value) return VALID;
      if (!isValidIdentifier(value)) {
        return { isValid: false, message: translator.getError("invalid_identifier") };
      }
      return VALID;

    case "service_provider_id":
      if (!value) return VALID;
      if (!isValidIdentifier(value)) {
        return { isValid: false, message: translator.getError("invalid_identifier") };
      }
      return VALID;

    case "id_340b_raw":
      if (!isValidId340b(value)) {
        return {
          isValid: false,
          message: translator.getError("invalid_id_340b"),
        };
      }
      return VALID;

    case "health_plan_id":
      if (!isValidHealthPlanId(value)) {
        return { isValid: false, message: translator.getError("invalid_health_plan_id") };
      }
      return VALID;

    case "health_plan_name":
      if (!isValidHealthPlanName(value)) {
        return {
          isValid: false,
          message: translator.getError("invalid_health_plan_name"),
        };
      }
      return VALID;

    case "claim_number":
      if (!isValidClaimNumber(value)) {
        return { isValid: false, message: translator.getError("invalid_claim_number") };
      }
      return VALID;

    case "claim_line_number":
      if (!isValidClaimLineNumber(value)) {
        return {
          isValid: false,
          message: translator.getError("invalid_claim_line_number"),
        };
      }
      return VALID;

    case "hcpcs_code":
      if (!isValidHCPCS(value)) {
        return {
          isValid: false,
          message: translator.getError("invalid_hcpcs_code"),
        };
      }
      return VALID;

    case "hcpcs_code_modifier_1":
    case "hcpcs_code_modifier_2":
    case "hcpcs_code_modifier_3":
    case "hcpcs_code_modifier_4":
      if (!isValidHCPCSMod(value)) {
        return { isValid: false, message: translator.getError("invalid_alphanumeric_2") };
      }
      return VALID;

    case "unit_of_measure":
      if (!isValidUnitOfMeasure(value)) {
        return { isValid: false, message: translator.getError("invalid_uom") };
      }
      return VALID;

    case "wholesaler_invoice_number":
      if (!isValidWholesalerInvoiceNumber(value)) {
        return {
          isValid: false,
          message: translator.getError("invalid_wholesaler_invoice_number"),
        };
      }
      return VALID;
  }

  return VALID;
};

const checkRequired = (column, value) => {
  if (isRequiredField(column) && isBlank(value)) {
    return { isValid: false, message: translator.getError("field_required", { column }) };
  }
  return VALID;
};

export const crossFieldErrors = (data) => hcpcsOrUnitOfMeasureCrossFieldErrors(data, translator);

export default isValidMedicalClaimField;
